export const LIST_CHANNELS = '@channels/LIST'

export const CHANNELS_LABEL_MAP = {
  whatsapp: 'WhatsApp',
  whatsapp_bot: 'WhatsApp Bot',
  whatsapp_bot_zs: 'WhatsApp Bot ZS',
  rappi: 'Rappi',
  magento_ecommerce: 'Ecom (Magento)',
  vtex_ecommerce: 'Ecom (VTEX)',
  vtex_seasonal: 'Ecom VTEX Seasonal',
  vtex: 'E-commerce'
}
